import { render, staticRenderFns } from "./ProductsCatalog.vue?vue&type=template&id=ee853c66&scoped=true"
import script from "./ProductsCatalog.vue?vue&type=script&lang=js"
export * from "./ProductsCatalog.vue?vue&type=script&lang=js"
import style0 from "./ProductsCatalog.vue?vue&type=style&index=0&id=ee853c66&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee853c66",
  null
  
)

export default component.exports